export const SMS_RESULT_OK                              = 1;
export const SMS_RESULT_NO_ATTEMPTS_LEFT                = 2;
export const SMS_RESULT_WRONG_CODE                      = 3;
export const SMS_RESULT_SEND_CODE_SUCCESS               = 4;
export const SMS_RESULT_PHONE_NOT_FOUND                 = 10;
export const SMS_RESULT_ERROR                           = 11;
export const SMS_RESULT_REQUIRES_OLD_PHONE_CONFIRMATION = 12;

export const SMS_STATE_IDLE                           = 'IDLE';
export const SMS_STATE_WAITING                        = 'WAITING';
export const SMS_STATE_AWAITING_FIRST_CODE_REQUEST    = 'AWAITING_FIRST_CODE_REQUEST';
export const SMS_STATE_AWAITING_REPEATED_CODE_REQUEST = 'AWAITING_REPEATED_CODE_REQUEST';
export const SMS_STATE_ENTERING_CODE                  = 'ENTERING_CODE';
export const SMS_STATE_AWAITING_CODE_SEND             = 'AWAITING_CODE_SEND';
